import ProviderPendingUserList from './components/ProviderPendingUserList.js';
import connect from './connect';
import './assets/ProviderPendingUserList.css';

export default connect(ProviderPendingUserList);



// WEBPACK FOOTER //
// ./src/routes/ProviderPendingUserList/index.js